/**
 * 案件・承認・確定（F4）の Query キー。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 案件の読取と承認の Query キーを定義する。
 * @graph-connects none
 */
import type { LocaleKeyPart } from './common.js';

/** 案件の仕様グラフ読取のキー。 @graph-connects none */
export const pjSpecGraphQueryKeys = {
  /*
   * 案件の読取 3 本のキー。案件番号は number である。
   *
   * 言語は載せない。返るのは案件番号・状態・時刻・件数と、要求の本文である。要求の本文は
   * 案件の担当者が書いた原文で、訳す対象ではない。
   */
  listPjs: () => ['specGraph', 'listPjs'] as const,
  getChangeHistory: (pjNumber: number) => ['specGraph', 'getChangeHistory', pjNumber] as const,
  listPjRequirements: (pjNumber: number) => ['specGraph', 'listPjRequirements', pjNumber] as const,
  /*
   * 案件の差分（欄ごとの変更前・変更後）。表示名が言語で替わるので言語を載せる。
   */
  getPjDiff: (pjNumber: number, locale: LocaleKeyPart) =>
    ['specGraph', 'getPjDiff', pjNumber, locale ?? null] as const,
  /*
   * 案件の憲章。言語は載せない。本文は起票した人が書いた原文で、欄の名前は画面が訳す。
   */
  getPjCharter: (pjNumber: number) => ['specGraph', 'getPjCharter', pjNumber] as const,
} as const;

/** 承認の Query キー。 @graph-connects none */
export const pjSpecPjQueryKeys = {
  /** 本人が承認を積める担当者か。利用者が変わらない限り変わらない。 */
  approvalAccess: () => ['specPj', 'approvalAccess'] as const,
  /*
   * 案件を跨ぐ承認の一覧。案件を持たないので鍵に案件を持たず、承認を積んだあとは言語を問わず
   * 全部を取り直す（接頭辞 `termChangesAcrossPjsAll` で無効化する）。承認状態は言語に依らない
   * ので、いま見ている言語だけ取り直すと、言語を切り替えた瞬間に古い状態が現れる。
   */
  termChangesAcrossPjsAll: () => ['specPj', 'listTermChangesAcrossPjs'] as const,
  listTermChangesAcrossPjs: (locale: LocaleKeyPart) =>
    ['specPj', 'listTermChangesAcrossPjs', locale ?? null] as const,
} as const;
